import type { ComponentProps, ReactNode } from 'react'
import styled from 'styled-components'

const StyledSpan = styled.span`
  color: var(--pill-internal-default-color);
  background-color: var(--pill-internal-default-background-color);
  border: var(--pill-internal-border-width, 1px) solid var(--pill-internal-default-border-color);
  box-sizing: border-box;
`

interface Props extends ComponentProps<typeof StyledSpan>, Utils.PropsWithDataAttributes {
  children?: ReactNode
}

function PillInternal({ children, ...props }: Props) {
  return <StyledSpan {...props}>{children}</StyledSpan>
}

export default PillInternal
